// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ComponentThemeProps } from "@insite/mobius/globals/baseTheme";
import { css } from "styled-components";

const DataTablePresentationPropsDefault: ComponentThemeProps["dataTable"]["defaultProps"] = {
    headerTypographyProps: {
        weight: "bold",
        size: 15,
    },
    cellTypographyProps: {
        size: 15,
    },
    sortClickableProps: {
        css: css`
            width: 100%;
            height: 100%;
            justify-content: space-between;
        `,
    },
    sortIconProps: {
        size: 15,
        css: css`
            margin-left: 8px;
        `,
    },
    sortIconSources: {
        sortable: "ChevronUp",
        ascending: "ChevronUp",
        descending: "ChevronDown",
        none: "Minus",
        other: "Activity",
    },
};

export default DataTablePresentationPropsDefault;
